import axios from 'axios'
import { baseUrl } from './config'

export function getStatisticsRounds (params) {
  return axios.get(`${baseUrl}/dice-game/game`, {
    params
  })
}

export function getMultiplier () {
  return axios.get(`${baseUrl}/dice-game/multiplier`)
}

export function updateMultiplier (multiplier) {
  return axios.post(`${baseUrl}/dice-game/multiplier`, {
    multiplier
  })
}

export function getGeneralStatistics () {
  return axios.get(`${baseUrl}/dice-game/statistics/general`)
}

export function startDice () {
  return axios.post(`${baseUrl}/dice-game/start`)
}

export function stopDice () {
  return axios.post(`${baseUrl}/dice-game/stop`)
}
